import React, {useEffect, useState} from 'react';
import {TableEditDelete} from './styles';
import Media from '../Media/Media';
import {Trash, Save} from '../../assets/icons/icons';
import Utils, {deepGet} from '../../utils/api/Utils';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';
export default ({
  dataTableContent,
  dataMainHead,
  dataTableHead,
  handleClick,
  onDelete,
  onEdit,
}: {
  dataTableContent: Array<any>;
  dataMainHead: Array<any>;
  dataTableHead: Array<{title: string; colSpan: any; examType: Array<any>; split?: any}>;
  handleClick?: any;
  onDelete?: any;
  onEdit?: any;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [reverse, useReverse] = useState<boolean>(false);
  const [isActive, setActiveClass] = useState('');
  const UTILS = new Utils();
  const isWord = UTILS.GetValidationInputPattern();
  const HandleSort = UTILS.HandleSort;
  const sortOptions = [reverse, useReverse, setActiveClass, useTable, table, isWord];
  useEffect(() => useTable(dataTableContent), [dataTableContent]);
  function createTableRow(element, atributes, index) {
    const columns = atributes.map((prop, index) => {
      if (prop.title === 'PLAYERS') {
        return (
          <td key={'name' + element._id}>
            <Media imgUrl={element.player.picture} name={`${element.player.fullName}`} />
          </td>
        );
      }
      if (prop.title === 'DATES' || prop.examType[0] === 'createdAt') {
        return <td key={'date' + element._id}>{new Date(deepGet(element, [...prop.examType])).toLocaleDateString('en-US') || '-'}</td>;
      }
      if (prop.title === 'EDIT' || prop.examType[0] === 'edit') {
        return (
          <td key={'edit' + element._id}>
            <span data-cy="editButton" onClick={() => onEdit(element._id)} style={{cursor: 'pointer'}}>
              <Save color={'#acb1c0'} />
            </span>
          </td>
        );
      }
      if (prop.title === 'DELETE' || prop.examType[0] === 'delete') {
        return (
          <td key={'delete' + element._id}>
            <span data-cy="deleteButton" onClick={() => onDelete(element._id)} style={{cursor: 'pointer'}}>
              <Trash />
            </span>
          </td>
        );
      }
      const value = deepGet(element, [...prop.examType]);
      return (
        <td key={element._id + '_' + index} style={{maxWidth: '80px', overflow: 'hidden'}}>
          {value === 0 ? value : value || '-'}
        </td>
      );
    });
    const key = Date.now() + element._id + '__' + index;
    return (
      <tr key={key} data-cy="table_edit_delete-row" onClick={() => (handleClick ? handleClick(element) : '')}>
        {columns}
      </tr>
    );
  }

  return (
    <>
      {
        <TableEditDelete>
          <thead>
            {dataMainHead.length > 0 ? (
              <tr>
                {dataMainHead.map((item, index) => (
                  <th key={index} colSpan={item.colSpan}>
                    {item.title}
                  </th>
                ))}
              </tr>
            ) : (
              <></>
            )}

            <tr>
              {dataTableHead.map((item, index) => {
                const b = item.title.split(' ');
                const splited = item.split ? item.split[0] : false;
                const a = () => {
                  if (splited) {
                    const first = b.slice(0, item.split[1]).map(word => (word = word + ' '));
                    const last = b.slice(item.split[1], b.length).map(word => (word = word + ' '));
                    return (
                      <>
                        {b.length > 1 ? (
                          <>
                            {first}
                            <br />
                            {last}
                          </>
                        ) : (
                          <>{b[0]}</>
                        )}
                      </>
                    );
                  } else {
                    return item.title;
                  }
                };

                return (
                  <th onClick={() => HandleSort(item.title, item.examType, sortOptions)} key={index} colSpan={1}>
                    <span>{a()}</span>
                    {isActive === item.title && reverse && <GoChevronDown />}
                    {isActive === item.title && !reverse && <GoChevronUp />}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className="table-player-exam">
            {table.length ? (
              table.map((item, index) => createTableRow(item, dataTableHead, index))
            ) : (
              <tr>
                <td colSpan={18}>No Data</td>
              </tr>
            )}
          </tbody>
        </TableEditDelete>
      }
    </>
  );
};
